import { Component, OnInit, OnChanges, ViewChild, Input, ComponentFactoryResolver } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReportService } from '../../shared/services/report.service';
import { SpinnerService } from '../../shared/components/spinner/spinner.service';
import { QCReport } from '../../shared/models/qcReport';
import { MailingRecord } from '../../shared/models/MailingRecord';
import { MailingRecordEditFormComponent } from '../../shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component';
import { MailingRecordService } from '../../shared/services/mailingRecord.service';
import { Mailing } from '../../shared/models/mailing';
import { MailingService } from '../../shared/services/mailing.service';

@Component({
  selector: 'app-qc-report',
  templateUrl: './qc-report.component.html'
})

export class QCReportComponent implements OnInit {
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<QCReport>();
  displayedColumns: string[] = ['mailingFile', 'brand', 'fullName', 'patientId', 'monthsOriginal', 'monthsConversion', 'campaignType', 'birthday', 'age', 'notes'];
  public loader1 = false;
  public showMsg = false;
  private sub: any;
  private id: number; // id
  public mailing: Mailing; // mailing model

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private reportService: ReportService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private notification: MatSnackBar,
    private spinnerService: SpinnerService,
    private mailingRecordService: MailingRecordService,
    private mailingService: MailingService,
  ) { }
  
  // init
  ngOnInit() {

    // show spinner on page load
    this.spinnerService.show();

    // get url parameter id 
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id']; // (+) converts string 'id' to a number

      this.getMailing(this.id);

      // hide spinner
      setTimeout(() => {
        this.spinnerService.hide();
      }, 1500);
    });
  }

  // get mailing details
  getMailing(id: number) {

    // get mailing
    this.mailingService.getById(this.id).subscribe(result => {

      this.mailing = result;

      // hide spinner
      setTimeout(() => {
        this.spinnerService.hide();
      }, 1500);

    }, error =>
      // console.error(error)
      this.router.navigate(['/mailings/'])
    );
  }
   

  // get records
  getRecords(): void {
    this.showMsg = false;
    this.spinnerService.show("In progress..."); 

    if (this.id > 0) {
      this.reportService.getMailingErrorReport(this.id).subscribe(result => {
        this.dataSource.data = result;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        if (result.length == 0) {         
          this.showMsg = true;
        }
        this.spinnerService.hide();
        //this.loader1 = false; 
      }, error => console.error(error));
    }
  }
   
  // filter 
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  }
   
  // edit mailing record 
  editMailingRecord(id: number) { 
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };
    this.mailingRecordService.getById(id).subscribe(record => {
      const modalRef = this.modalService.open(MailingRecordEditFormComponent, modalOptions);
      modalRef.componentInstance.title = 'Edit Record';
      modalRef.componentInstance.mailingRecord = record;

      // modal result
      modalRef.result.then((result) => {
        if (result) {
          this.showNotification('This mailing record has been saved successfully!', 'Okay!');
          //this.getRecords(this.mailingFileId);
        }
      }).catch(() =>
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      );
    }); 
  } 
}

